import React from "react";
import { makeStyles, Card, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  squareBlock: {
    width: "270px",
    height: "300px",
    backgroundColor: "#fff",
    margin: "10px",
    borderRadius: "5px",
    display: "flex",
    border: "2px solid #E1D9D1",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: "20px",
    transition: "background-color 0.3s ease",
    "&:hover": {
      background: "linear-gradient(270deg, #FF8008 0%, #FFC837 74.71%)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "13rem",
      height: "14rem",
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginTop: "15px", // Adjust the margin here
  },
  icon: {
    width: "50px",
    height: "50px",
    marginBottom: "10px", 
    [theme.breakpoints.down("sm")]: {
      width: "50px",
      height: "50px",
      marginBottom: "5px",
    },
  },
  heading: {
    fontSize: "19px",
    lineHeight: "18px",
    fontFamily: "jost",
    textAlign: "center",
    fontWeight: "bold",
  },
  subheading: {
    fontSize: "1rem",
    fontFamily: "Jost, sans-serif",
    color: "#7E7E7E",
    fontWeight: "400",
    lineHeight: "1.5",
    marginTop: "10px", 
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
    },
  },
}));

function SquareTrust({ iconName, heading, subheading }) {
  const classes = useStyles();

  return (
    <Card className={classes.squareBlock}>
      <div>
        <img src={iconName} alt="" className={classes.icon} />
      </div>
      <div className={classes.content}>
        <Typography variant="h6" className={classes.heading}>
          {heading}
        </Typography>
        <Typography variant="body2" className={classes.subheading}>
          {subheading}
        </Typography>
      </div>
    </Card>
  );
}

export default SquareTrust;
